import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Checkbox } from 'primereact/checkbox'

import { Button, Table } from '../../../helpers'

import Loading from '../../../common/Loading'

import { insertVendorRateContract } from '../../../services/api/vendorRateContract'

import { raiseToast } from '../../../services/redux/reducers/toast/toast'

import { getKeysTransformedToValuesObject, getProductName, getProductSpecification } from '../../../utils'
import { updateMaterialDetails, updateVendorRateContractItems } from '../../../services/redux/reducers/vendorRateContractItems/vendorRateContractItems'
import { updateVendorRateContractItemById } from '../../../services/api/vendorRateContractItem'


const ConfirmModal = (props) => {

    const { 
        vendorRateContract, 
        vendorRateContractItems, 
        setIsConfirmModalVisible, 
        materialDetails,
        materialBrands,
        setVisibleAddVendorRCItemModal,
        setVisibleEditVendorRCItemModal
    } = props

    const [isLoading, setIsLoading] = useState(false)
    const [declaration, setDeclaration] = useState(false)

    const dispatch = useDispatch()

    const vendorRateContractItemsData = useSelector(state => state.vendorRateContractItems.vendorRateContractItems)
    const materialData = useSelector(state => state.vendorRateContractItems.materialDetails)

    const getProductNameBody = (row) => {
        const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial.materialId === parseInt(row.materialId))
        let relatedBrand = materialBrands.find(eachMaterialBrand => eachMaterialBrand.brandId === relatedMaterial?.brandId)
        let productName = getProductName(relatedBrand?.brandName, relatedMaterial?.productName, relatedMaterial?.variantName)
        return (
            <div>{productName}</div> 
        )
    }

    const getProductSpecificationBody = (row) => {
        const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial.materialId === parseInt(row.materialId))
        let productSpecification = getProductSpecification(relatedMaterial?.productSpecification, relatedMaterial?.UOM, relatedMaterial?.UOMValue)
        return (
            <div>{productSpecification}</div> 
        )
    }

    let tableColumns = [
        {
            header: 'Material Id',
            field: "materialId"
        },
        {
            header: 'Product Name',
            field: getProductNameBody
        },
        {
            header: 'Product Specs',
            field: getProductSpecificationBody
        }
    ]

    const handleSubmit = async () => {
        let transformedGeoMapObj = getKeysTransformedToValuesObject(vendorRateContract.geoMap)
        let updatedVendorRateContract = {...vendorRateContract, geoMap: transformedGeoMapObj}

        let updatedVendorRateContractItems = vendorRateContractItems.map(eachVendorRateContractItem => {
            return {
                vendorRateContractId: vendorRateContract.vendorRateContractId ? vendorRateContract.vendorRateContractId : null,
                vendorRateContractItemId: eachVendorRateContractItem.vendorRateContractId ? eachVendorRateContractItem.vendorRateContractItemId : null,
                brandId: eachVendorRateContractItem.brandId,
                categoryId: eachVendorRateContractItem.categoryId,
                productName: eachVendorRateContractItem.productName,
                variantName: eachVendorRateContractItem.variantName,
                materialId: eachVendorRateContractItem.materialId,
                listPrice: eachVendorRateContractItem.listPrice,
                discount: eachVendorRateContractItem.discount,
                contractPrice: eachVendorRateContractItem.contractPrice,
                leadTime: eachVendorRateContractItem.leadTime,
                listPriceDate: eachVendorRateContractItem.listPriceDate,
                validFrom: eachVendorRateContractItem.validFrom,
                validTo: eachVendorRateContractItem.validTo,
                statusId: eachVendorRateContractItem.statusId,
                isNew: eachVendorRateContractItem.isNew,
                createdBy: eachVendorRateContractItem.createdBy,
                updatedBy: eachVendorRateContractItem.updatedBy
            }
        })

        let data = {
            vendorRateContract: updatedVendorRateContract,
            vendorRateContractItems: updatedVendorRateContractItems
        }

        if (window.confirm("Are you sure you want to continue...?")){
            setIsLoading(true)
            const isNewVendorRCItemExists = updatedVendorRateContractItems.some(eachVendorRateContractItem => eachVendorRateContractItem.isNew)
            if (vendorRateContract.isNew || isNewVendorRCItemExists){
                const vendorRateContractInsertionRes = await insertVendorRateContract(data)
                if (vendorRateContractInsertionRes.failure){
                    setIsLoading(false)
                    return dispatch(raiseToast({severity:'error', detail: vendorRateContractInsertionRes.data.error, summary: 'Vendor Rate Contract is not Inserted', life: 3000}))
                }
    
                let updatedVendorRateContractItemsData = [...vendorRateContractInsertionRes.data.vendorRateContractItemsRes, ...vendorRateContractItemsData]
                dispatch(updateVendorRateContractItems(updatedVendorRateContractItemsData))
                dispatch(updateMaterialDetails([...materialData, ...materialDetails]))
    
                setIsLoading(false)
                setIsConfirmModalVisible(false)
                setVisibleAddVendorRCItemModal(false)
                dispatch(raiseToast({severity:'success', detail: 'Vendor Rate Contract created Successfully', life: 3000}))
            }else {
                const vendorRateContractupdationRes = await updateVendorRateContractItemById(updatedVendorRateContractItems[0].vendorRateContractItemId, updatedVendorRateContractItems[0])
                if (vendorRateContractupdationRes.failure){
                    setIsLoading(false)
                    return dispatch(raiseToast({severity:'error', detail: vendorRateContractupdationRes.data.error, summary: 'Vendor Rate Contract is not Updated', life: 3000}))
                }

                let updatedVendorRateContractItemsData = []
                vendorRateContractItemsData.map(eachVendorRateContractItem => {
                    if (eachVendorRateContractItem.vendorRateContractItemId === updatedVendorRateContractItems[0].vendorRateContractItemId){
                        updatedVendorRateContractItemsData.push(vendorRateContractupdationRes.data)
                    }else {
                        updatedVendorRateContractItemsData.push(eachVendorRateContractItem)
                    }
                })
                dispatch(updateVendorRateContractItems(updatedVendorRateContractItemsData))
                dispatch(updateMaterialDetails([...materialData, ...materialDetails]))
    
                setIsLoading(false)
                setIsConfirmModalVisible(false)
                setVisibleEditVendorRCItemModal(false)
                dispatch(raiseToast({severity:'success', detail: 'Vendor Rate Contract updated Successfully', life: 3000}))
            }
        }
    }


    return (
        <>
            <Loading visible={isLoading}/>
            <Table
                tableColumns={tableColumns}
                data={vendorRateContractItems}
                scrollable="true"
            />
            <div className="font-bold mt-4">
                ACKNOWLEDGEMENT:
            </div>
            <div className="mt-2">
                <div className="flex flex-row col-12 mb-2 lg:col-12 lg:mb-0">
                    <Checkbox onChange={e => setDeclaration(e.checked)} checked={declaration} style={{ textAlign: "center" }}></Checkbox>
                    <label style={{ marginBottom: "5px", fontSize: "13px", marginLeft: "8px" }} >I hereby declare that the information given in this rate contract is true and correct to the best of my knowledge and belief.</label>
                </div>
            </div>
            <div className="flex justify-content-center mt-5">
                <Button className="" label="SUBMIT" outlined onClick={handleSubmit} disabled={!declaration}/>
            </div>
        </>
    )
}

export default ConfirmModal